import { useState } from "react";
import { PiCaretUpDownFill } from "react-icons/pi";
import { Dropdown, Popover, Whisper, Button } from "rsuite";
import styled from "styled-components";

const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: bold;
`;

const ButtonContainer = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  background: var(--clr-white-100);
  outline: none;
  border: none;
  border: 1px solid var(--clr-grey-100);
  padding: 10px;
  text-align: left;
  transition: all 0.5s ease;
  width: 100%;

  &:focus {
    border-color: var(--clr-black);
    color: var(--clr-black);
  }

  &:hover {
    background: none;
  }
`;

const PopoverContainer = styled(Popover)`
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 5px;
  border: 1px solid var(--clr-white-100);
  backdrop-filter: blur(2px);
  min-width: 100px;
  max-width: 200px;
  max-height: 300px;
  overflow-y: auto;

  .rs-dropdown-item {
    color: var(--clr-black);
    font-size: 12px;
    font-style: normal;
    font-weight: var(--fw-bold);
    line-height: 16px;
  }
`;

const renderSpeaker = (
  { onClose, left, top, className, ...rest }: any,
  ref: any,
  dropdownItems: string[],
  handleDropdownSelect: any,
  name?: string,
  valueName?: string,
  setOpen?: any
) => {
  const handleSelect = (e: any) => {
    handleDropdownSelect(name, e?.value);
    handleDropdownSelect(valueName, e?.label);
    setOpen(false);
  };
  return (
    <PopoverContainer
      ref={ref}
      className={className}
      style={{ left, top }}
      full
    >
      <Dropdown.Menu onSelect={handleSelect}>
        {dropdownItems?.map((item: any, index: any) => (
          <Dropdown.Item key={index} eventKey={item} value={item?.value}>
            {item?.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </PopoverContainer>
  );
};

interface DropdownProps {
  dropdownItems?: any;
  title?: any;
  handleDropdownSelect?: any;
  name?: string;
  value?: any;
  valueName?: string;
}

const UnderlinedSelector = ({
  dropdownItems,
  title,
  handleDropdownSelect,
  name,
  value,
  valueName,
}: DropdownProps) => {
  const [open, setOpen] = useState<any>(false);

  return (
    <SelectorContainer>
      {title && <Label>{title}:</Label>}
      <Whisper
        // open={open}
        onClick={() => setOpen(true)}
        placement="bottomStart"
        trigger={["click"]}
        speaker={renderSpeaker(
          ``,
          ``,
          dropdownItems,
          handleDropdownSelect,
          name,
          valueName,
          setOpen
        )}
        onBlur={() => setOpen(false)} 
      >
        <ButtonContainer>
          <span>
            {!dropdownItems?.filter((x: any) => x?.value === value)[0]?.label
              ? title
              : dropdownItems?.filter((x: any) => x?.value === value)[0]?.label}
          </span>
          <PiCaretUpDownFill />
        </ButtonContainer>
      </Whisper>
    </SelectorContainer>
  );
};

export default UnderlinedSelector;
